import { Button, Stack } from '@mui/material';

const DepartureModeStep = ({ busy, onManual, onAuto }) => {
  return (
    <Stack gap={1.5} alignItems="center" py={1}>
      <Button
        fullWidth
        variant="contained"
        disabled={busy}
        onClick={onManual}
        sx={{ minHeight: 48 }}
      >
        برداشت دستی
      </Button>

      <Button
        fullWidth
        variant="contained"
        disabled={busy}
        onClick={onAuto}
        sx={{ minHeight: 48 }}
      >
        برداشت اتوماتیک
      </Button>
    </Stack>
  );
};

export default DepartureModeStep;
